import pdfMake from 'pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import useDate from '@/services/utils/day';
import pdfHeaderFooter from '@/services/utils/pdf/pdfHeaderFooter';
pdfMake.vfs = pdfFonts.pdfMake.vfs;

const pdfPrinter = () => {
    const { formatToDdMmYy } = useDate();
    const { getHeader } = pdfHeaderFooter();

    const exportToPDF = (company, reportList, date) => {

        var doc = {
            pageSize: 'A4',
            pageMargins: [ 30, 100, 30, 60 ],
            header: getHeader(company),
            content: getContent(reportList, date),

            styles : {
                header: {
                    fontSize: 24
                }
            },
            defaultStyle: {
                color: 'black',
                fontSize: 10,
            },
            info: {
                title: 'OPD Billing Report'
            }
        }

        const pdfDocGenerator = pdfMake.createPdf(doc);
        pdfDocGenerator.open();
    }

    const getContent = (reportList, date) => {
        return [
            {
                text: 'OPD Billing Report',
                style: 'header',
                alignment: 'center',
                margin: [0, 0, 20, 10],
                bold: true,
                color: 'black',
                decoration: 'underline'
            },

            {
                stack: [
                    {
                        text: `Date: ${formatToDdMmYy(date.start_date)} To ${formatToDdMmYy(date.end_date)}`
                    }
                ]
            },

            {
                style: 'tableExample',
                margin: [0, 10, 0, 0],
                table: {
                    widths: ['auto', '*', 'auto'],
                    body: getTableBody(reportList)
                },
                layout: {
                    fillColor: function (rowIndex, node, columnIndex) {
                        return (rowIndex === 0) ? '#f3f2f7' : null;
                    },
                    hLineWidth: function (i, node) {
                        return 0.5;
                    },
                    vLineWidth: function (i, node) {
                        return 0.5;
                    }
                }
            },
        ]
    }

    const getTableBody = (reportList) => {
        const header = getTableHead();
        const row = getTableRow(reportList);
        return [
            header,
            ...row
        ]
    }

    const getTableRow = (reportList) => {
        const data = [];
        reportList.map((child, index) => {
            const row = [
                { text: index + 1 },
                { text: child.consultant_name },
                { text: child.total_count, alignment: 'right' }
            ];
            data.push(row);
        })
        const totalRow = [
            { text: 'Total', colSpan: 2, alignment: 'right' },
            { text: '' },
            { text: totalCount(reportList), alignment: 'right' },
        ];

        data.push(totalRow);
        return data
    }

    const totalCount = (data) => {
        return data.reduce((sum, child) => sum + child.total_count, 0)
    }

    const getTableHead = () => {
        return [
            { text: 'SL' },
            { text: 'NAME OF CONSULTANT' },
            { text: 'TOTAL COUNT' , alignment: 'right' }
        ]
    }

    return {
        exportToPDF
    }
}

export default pdfPrinter;
